import { render } from "./LinkageSignupCode.vue?vue&type=template&id=2de4d0c5&scoped=true&ts=true"
import script from "./LinkageSignupCode.vue?vue&type=script&lang=ts"
export * from "./LinkageSignupCode.vue?vue&type=script&lang=ts"

import "./LinkageSignupCode.vue?vue&type=style&index=0&id=2de4d0c5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2728993903/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de4d0c5"]])

export default __exports__